<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>员工模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'employeeList' }">员工列表</el-breadcrumb-item>
            <el-breadcrumb-item>员工工作量</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="6">
        <div>
          <span>{{name}}({{tel}})</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <span>总提成:{{totalSalary}}（元）</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <span>确认提成:{{totalCheckSalary}}（元）</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <span>未确认提成:{{totalUncheckSalary}}（元）</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="8">
        <div class="grid-content">
          时间：
          <el-date-picker v-model="moment"
                          type="daterange"
                          style="width: 220px;"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          批次:
          <el-select v-model="batchId"
                     filterable
                     clearable
                     placeholder="请选择">
            <el-option v-for="item in batchList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <el-button type="primary"
                   size="medium"
                   @click="search">查询</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="add">新增</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="salaryExports">导出</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData"
              border
              style="width: 95%">
      <el-table-column prop="workDate"
                       label="日期"></el-table-column>
      <el-table-column prop="batchName"
                       label="批次"></el-table-column>
      <el-table-column prop="checkStates"
                       label="工序确认"></el-table-column>
      <el-table-column prop="processName"
                       label="工序"></el-table-column>
      <el-table-column prop="unitPrice"
                       label="单价（元）"></el-table-column>
      <el-table-column prop="amount"
                       label="完成件数"></el-table-column>
      <el-table-column prop="salary"
                       label="提成（元）"></el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="100">
        <template slot-scope="scope">
          <el-button @click="goDetails(scope.row)"
                     type="text"
                     size="small">详情</el-button>
          <el-button @click="del(scope.row)"
                     type="text"
                     size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="totalCount"
                   :page-size="pageSize"
                   :page-count="pageTotal"></el-pagination>
  </div>
</template>
<script>
import { getLast } from "@/util/time";
import { getCheckState } from "@/util/enum";
import { batchSel } from "@/api/batch";
import {
  workRecordSel,
  workRecordDel,
  workRecordExport
} from "@/api/workRecord";
import moment from "moment";
export default {
  data () {
    return {
      batchList: [],
      batchId: "",
      tableData: [],
      id: "",
      name: "",
      tel: "",
      totalSalary: 0,
      totalCheckSalary: 0,
      totalUncheckSalary: 0,
      moment: getLast(new Date()),
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0
    };
  },
  mounted () {
    this.name = this.$route.query.staffName;
    this.id = this.$route.query.id;
    this.moment = getLast(new Date(this.$route.query.month));
    this.tel = this.$route.query.tel;
    this.getList();
    this.batchList = [];
    this.getBatch(1, 1);
  },
  methods: {
    add () {
      this.$router.push({
        path: "/home/enterprise/personnel/employeeWorkloadadd",
        query: {
          id: this.id,
          staffName: this.name,
          tel: this.tel,
          month: moment(new Date(this.moment[0])).format("YYYY-MM")
        }
      });
    },
    goDetails (row) {
      this.$router.push({
        path: "/home/enterprise/personnel/employeeWorkloaddetails",
        query: {
          id: this.id,
          staffName: this.name,
          tel: this.tel,
          month: moment(new Date(this.moment[0])).format("YYYY-MM"),
          work: row
        }
      });
    },
    del (row) {
      this.$confirm(
        "删除“" +
        row.staffName +
        "”员工" +
        row.workDate +
        "的" +
        row.amount +
        "件“" +
        row.processName +
        "”工作" +
        ", 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          const params = {
            id: row.id
          };
          workRecordDel(params)
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    search () {
      this.handleCurrentChange(1);
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getList();
    },
    getList () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        userId: this.id,
        batchId: this.batchId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.moment) {
        params.beginTime = moment(new Date(this.moment[0])).format(
          "YYYY-MM-DD"
        );
        params.endTime = moment(new Date(this.moment[1])).format("YYYY-MM-DD");
      }
      workRecordSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          var tableData = [];
          res.gridData.forEach(element => {
            element.workDate = moment(new Date(element.workDate)).format(
              "YYYY-MM-DD"
            );
            element.unitPrice = (element.salary / element.amount).toFixed(4);
            element.checkStates = getCheckState(element.checkState);
            tableData.push(element);
          });
          this.tableData = tableData;
          this.totalSalary = res.totalSalary ? res.totalSalary : 0;
          this.totalCheckSalary = res.totalCheckSalary
            ? res.totalCheckSalary
            : 0;
          this.totalUncheckSalary = res.totalUncheckSalary
            ? res.totalUncheckSalary
            : 0;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBatch (pageNum, progress) {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        username: localStorage.getItem("user_name"),
        progress: progress,
        pageNum: pageNum,
        pageSize: 100
      };

      batchSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            var batch = {
              value: element.id,
              label: element.title
            };
            this.batchList.push(batch);
          });
          if (pageNum < res.page.page_total) {
            this.getBatch(pageNum + 1, progress);
          } else if (progress == 1) {
            this.getBatch(1, 2);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    salaryExports () {
      if (this.totalSalary != this.totalCheckSalary) {
        this.$message({
          type: "error",
          message: "有未确认的工序，不能导出！"
        });
        return;
      }
      const params = {
        userId: this.id,
        batchId: this.batchId
      };
      var name = this.name;
      if (this.moment) {
        params.beginTime = moment(new Date(this.moment[0])).format(
          "YYYY-MM-DD"
        );
        params.endTime = moment(new Date(this.moment[1])).format("YYYY-MM-DD");
        name = this.name + params.beginTime + "-" + params.endTime;
      }
      workRecordExport(params, name);
    }
  }
};
</script>
